import './App.css';
import NavigationBar from './sections/NavigationBar';
import HomeSection from './sections/HomeSection';
import OurWorkSection from './sections/OurWorkSection';
import OrderStampSection from './sections/OrderStampSection';
import ContactSection from './sections/ContactSection';
import AboutSection from './sections/AboutSection';

function App() {
  return (
    <div className="App" id="home">
      <NavigationBar />
      <HomeSection />
      <OurWorkSection />
      <OrderStampSection />
      <ContactSection />
      <AboutSection />
    </div>
  );
}

export default App;
